import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { apiCallGetReportActionsAnalytics } from "../../../api/auditor-api/api-call-get-report-actions-analytics";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { TReportAction, TTBWEventStats } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class ReportActionsAnalyticsStore {
  fromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  toDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );
  reportActions = observable.box<TReportAction>([]);
  tbwEventStats = observable.box<TTBWEventStats>([]);

  setReportActions = (report: TReportAction) => {
    runInAction(() => {
      this.reportActions.set(report);
    });
  };

  setTBWEventStats = (stats: TTBWEventStats) => {
    runInAction(() => {
      this.tbwEventStats.set(stats);
    });
  };

  getReportActionsAnalytics = async () => {
    getCoreUIStore().setIsLoading("AUDITOR_REPORT_ACTIONS_ANALYTICS", true);
    const { data, status, code } = await apiCallGetReportActionsAnalytics({
      startDate: this.fromDate.get(),
      endDate: this.toDate.get()
    });
    getCoreUIStore().setIsLoading("AUDITOR_REPORT_ACTIONS_ANALYTICS", false);

    if (status === "OK") {
      this.setReportActions(data.reportAction);
      this.setTBWEventStats(data.tbwEventStats);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}
export const getReportActionsAnalyticsStore = memoize(
  () => new ReportActionsAnalyticsStore(),
  () => 1
);
export default getReportActionsAnalyticsStore;
